import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
const DefaultLink = (props) => {

	const onClick = (e) => {
		if (props.itemProps.hasSubMenu) {
			props.itemProps.toggleSubMenu(e)
		} else {

			props.itemProps.activateMe({
				newLocation: props.to,
				selectedMenuLabel: props.label,
			});
		}
	}

	const { menuIcon, subMenuIcon, itemProps } = props
	if (itemProps.id === 'Directories' || itemProps.id === 'UiElements') {
		return (
			<span className="g_heading">
				{itemProps.label}
			</span>
		);
	} else {
		return (
			<span className={window.location.pathname === itemProps.to ? "active" : ""}>
				<NavLink to={`${itemProps.to}`} onClick={(e) => onClick(e)} className={window.location.pathname === itemProps.to ? menuIcon : subMenuIcon}>
					{itemProps.children[0].props.className ? itemProps.children : itemProps.label}
				</NavLink>
			</span>
		);
	}

};
const mapStateToProps = (state) => ({
	subMenuIcon: state.settings.isSubMenuIcon,
	menuIcon: state.settings.isMenuIcon
})

const mapDispatchToProps = (dispatch) => ({})
export default connect(mapStateToProps, mapDispatchToProps)(DefaultLink);